import { useEffect } from 'react';

import { useDomain, useIdentitySiteUrls } from '@netfront/gelada-identity-library';
import { useToast } from 'hooks';
import { useRouter } from 'next/router';


const Dashboard = () => {
  const { isDomainReady } = useDomain();
  const { getBaseUrl: identityBaseUrl } = useIdentitySiteUrls({
    environment: process.env.REACT_APP_ENVIRONMENT,
    port: process.env.REACT_APP_IDENTITY_SITE_LOCAL_PORT,
  });

  const { push } = useRouter();
  const { handleToastError } = useToast();


  useEffect(() => {
    if (!isDomainReady) {
      return;
    }

    const identityUrl = `${identityBaseUrl()}/dashboard`;

    push(identityUrl).catch((error) =>
      handleToastError({
        error,
      }),
    );


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDomainReady]);

  return <></>;
};

// eslint-disable-next-line import/no-default-export
export default Dashboard;
